import { ColumnCalcTransformRule, IfErrorType } from 'src/app/domainObjects/transformers/columnCalcTransform';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { DataType } from './columnCalcViewModel';

export class ColumnCalcRuleViewModel extends TransformRuleViewModel {

    targetField: string;
    expression: string;
    ifError: IfErrorType;
    run: boolean;
    targetDataType: DataType;
    result: string;
    details: string;
    targetFarmColumns: string[] = [];

    tooltipMessageTargetField:string;
    tooltipTypeTargetField:string;
    tooltipMessageExpression:string;
    tooltipTypeExpression:string;
    
    constructor(rule: ColumnCalcTransformRule) {
      super(rule.ruleId, rule.index, rule.run, rule.ruleName);
  
      this.run = rule.run;
      this.targetDataType = rule.targetDataType;
      this.targetField = rule.targetField;
      this.expression = rule.expression;
      this.ifError = rule.ifError;
    }
  
    toRule(): ColumnCalcTransformRule {
      const rule = new ColumnCalcTransformRule();

      rule.ruleName = this.name;
      rule.index = this.index - 1;
      rule.targetDataType = this.targetDataType;
      rule.targetField = this.targetField;
      rule.expression = this.expression;
      rule.ifError = this.ifError;
      rule.run = this.run;

      return rule;
    }
  }
